module.exports = __webpack_public_path__ + "img/emitFacebeauty02.e36ae12f.png";